import { lazy } from 'react';

const ProfilePageConfig = {
  settings: {
    layout: {
      config: {}
    }
  },
  routes: [
    {
      path: '/profile',
      component: lazy(() => import('./profile')),
      title: 'Kullanıcı Profili',
      isAuthProtected: true
    }
  ]
};

export default ProfilePageConfig;
